module.exports = __webpack_public_path__ + "static/img/7.325dfd3e.png";